var map = {
	"./en/index.js": [
		36712,
		712
	],
	"./gu/index.js": [
		67812,
		812
	],
	"./hi/index.js": [
		15632,
		632
	],
	"./kn/index.js": [
		60410,
		410
	],
	"./mr/index.js": [
		43441,
		441
	],
	"./ne/index.js": [
		64776,
		776
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 56430;
module.exports = webpackAsyncContext;